const namespace = 'pager';

type Options = Partial<PagerOptions>;

export interface PagerOptions {
  isControlled: boolean;
  itemSelector: string;
  selector: string;
}

export class Pager {
  static defaults = {
    isControlled: false,
    itemSelector: '[data-pager-link]',
    selector: '[data-pager]',
  };
  options: PagerOptions;
  clickHandler: EventListener;

  constructor(options: Options = {}) {
    this.options = {
      ...Pager.defaults,
      ...options,
    };
    this.bind();
  }

  bind() {
    this.clickHandler = this.handleClick.bind(this);
    document.documentElement.addEventListener('click', this.clickHandler);
  }

  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    const element = target.closest(this.options.itemSelector);

    if (!element || !this.options.isControlled) {
      return;
    }

    event.preventDefault();
    const url = element.getAttribute('href');

    if (!url) {
      return;
    }

    this.dispatch(url);
  }

  dispatch(url: string) {
    const event = new CustomEvent(`${namespace}:updated`, {
      bubbles: true,
      detail: {
        url,
      },
    });

    document.dispatchEvent(event);
  }

  destroy() {
    document.documentElement.removeEventListener('click', this.clickHandler);
  }
}
